import http from 'conversations-http/clients/http';
export const fetchThreadMetadata = ({
  threadId
}) => {
  const url = `conversations-threads/v1/threads/${threadId}`;
  return http.get(url);
};